import { Component, ViewChild, Output, TemplateRef, ElementRef  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { EjercicioMes } from '../models/EjercicioMes';
import { Datos } from '../models/Datos';
import { DatosEnviar } from "../models/DatosEnviar";
import { MesE } from '../models/MesE';
import { ArbolCoas } from "../models/ArbolCoas";

import { TreeNode } from "../models/TreeNode";

import { TreeModule, TreeComponent } from 'angular-tree-component';
import { TREE_ACTIONS, KEYS, IActionMapping, ITreeOptions } from 'angular-tree-component';



import { CscaeService } from '../services/cscae.service';
import { Estructura } from '../models/EstructuraTabla';
import { DatosEditar } from '../models/DatosEditar';


@Component({
    selector: 'home',
    templateUrl: './home.component.html'
})
export class HomeComponent {


    CodigoPrimario: string ;
    CodigoSecundario: string ;

    Datos: Datos[];
    DatosEnviar: DatosEnviar;

    EjercicioActual: number;
    MesActual: string;
    MesActualString: string;

    modalRef: BsModalRef;

    TambienPuedeEditar: string[] = new Array<string>();
    PuedeEditar: boolean = false;
    desplegado: boolean = false;
    sideBarAbierta: boolean = false;
    Loading:boolean = false;

    ResumenDatos: MesE[];

    Estructura: Estructura[];

    EntidadActual: ArbolCoas;
    EntidadInicial: string;
    EntidadUnica:boolean = false;

    ArbolProvinciasHijas: ArbolCoas[];

    ArbolGestionados: ArbolCoas[];

    ArbolProvinciasHijasEntidadActual: ArbolCoas[];

    nodes: TreeNode[] = new Array<TreeNode>();

    @ViewChild('sideBar') sideBar:any;
    @ViewChild('openNav') openNav: any;

    @ViewChild("ModalEdit")
    ModalEdit: TemplateRef<any>;
    
    @ViewChild(TreeComponent)
    private tree: TreeComponent;

  

    options: ITreeOptions = {
        actionMapping: {
            mouse: {
                click: (tree: any, node: any, $event: any) => this.CambioEntidad(tree, node, $event)
            },
            keys: {
                [KEYS.ENTER]: (tree: any, node: any, $event: any) => this.CambioEntidad(tree, node, $event)
            }
        }
    }
    
    constructor(private activatedRoute: ActivatedRoute, private _cscaeService: CscaeService,
        private location: Location, private router: Router, private modalService: BsModalService){
       

       this.nodes.push(new TreeNode());

       this._cscaeService.GetEstructura()
           .subscribe(data => this.Estructura = data);

       this.EjercicioActual = (new Date()).getFullYear();

       this.DatosEnviar = new DatosEnviar();
       this.ArbolProvinciasHijasEntidadActual = new Array<ArbolCoas>();
       
       let hash = this.activatedRoute.snapshot.paramMap.get('hash');

       if (hash != null) {
           this.CodigoPrimario = hash.substring(0, 2).toUpperCase();
           this.CodigoSecundario = hash.substring(2).toUpperCase();

           this.EntidadActual = new ArbolCoas();

           this.IniciarArbol(this.CodigoPrimario, this.CodigoSecundario);

           if (this.CodigoSecundario != "XX") {
               this._cscaeService.GetEntidadesHijas(this.CodigoPrimario, this.CodigoSecundario)
                   .subscribe(datay =>{ this.ArbolProvinciasHijas = datay

                   });
           }

           this.ArbolProvinciasHijas = this.ArbolProvinciasHijasEntidadActual;

           //this.EstaCargado();

           // Generate the URL:
           //let url = this.router.url.split("/");
           //url.pop();
           //url.pop();
           //url.pop();
           //let baseURL = url.concat();
       }
   }    

   IniciarArbol(codigoPrimario: string, codigoSecundario: string) {
    this.CodigoPrimario = codigoPrimario;
    this.CodigoSecundario = codigoSecundario;

    this.ArbolGestionados = new Array<ArbolCoas>();

    this.NodoPadre(codigoPrimario, codigoSecundario);

    this._cscaeService.GetEntidad(codigoPrimario, codigoSecundario)
        .subscribe(data => {
            this.EntidadActual = data
            this.EntidadInicial = this.EntidadActual.descripcion;

            if (data.gestiona[0].length > 2 || data.gestiona.length > 1) {
                this.TambienPuedeEditar.push(codigoPrimario + codigoSecundario);
                for (let gestionado of data.gestiona) {
                    if (gestionado.length > 2) {
                        let cPrimario = gestionado.substring(0, 2);
                        let cSecundario = gestionado.substring(2);
                        
                        this.NuevoNodoGestionado(cPrimario, cSecundario);
                    }
                }
            }
            
            this._cscaeService.GetEntidadesHijas(codigoPrimario, codigoSecundario)
                    .subscribe(datay => {
                        this.NuevoNodoHijos(datay);
                        if(this.nodes[1].children[0] == undefined && this.TambienPuedeEditar[0] == undefined){
                            this.PuedeEditar = true;
                            this.EntidadUnica = true;
                        }else if(this.nodes[1].children[0].name != undefined){
                            this.sideBarAbierta = true;
                        }
                        if(this.TambienPuedeEditar[0] != undefined){
                            this.PuedeEditar = true;
                        }
                    });
        });
    this.Resumen(this.EjercicioActual, this.CodigoPrimario, this.CodigoSecundario);
}

NodoPadre(cPrimario: string, cSecundario: string) {
    
    let newNode: TreeNode = new TreeNode();
    newNode.id = cPrimario + cSecundario;

    this._cscaeService.GetEntidad(cPrimario, cSecundario)
        .subscribe(dataz => {
            newNode.name = dataz.descripcion;
            newNode.children = new Array<TreeNode>();
            this.nodes.push(newNode);
            
            let nodes = this.nodes;
            this.nodes = [];
            this.nodes = nodes;
        });
        console.log("nodopadre");
        
}

NuevoNodo(cPrimario: string, cSecundario:string) {
    console.log("nodo");

    let newNode: TreeNode = new TreeNode();
    newNode.id = cPrimario + cSecundario;

    this._cscaeService.GetEntidad(cPrimario, cSecundario)
        .subscribe(dataz => {
            newNode.name = dataz.descripcion;
            this.nodes[0].children = new Array<TreeNode>();
            this.nodes[0].children.push(newNode);

            let nodes = this.nodes;
            this.nodes = [];
            this.nodes = nodes;
        });
        
}

NuevoNodoGestionado(cPrimario: string, cSecundario:string) {
    let newNode: TreeNode = new TreeNode();
    newNode.id = cPrimario + cSecundario;

    this._cscaeService.GetEntidad(cPrimario, cSecundario)
        .subscribe(dataz => {
            newNode.name = dataz.descripcion;
            this.nodes[1].children = new Array<TreeNode>();
            this.nodes[1].children.push(newNode);

            let nodes = this.nodes;
            this.nodes = [];
            this.nodes = nodes;
        });
        console.log("nodo");
        
}

NuevoNodoHijos(datax:any) {
    for (let entidad of datax) {
        let newNode: TreeNode = new TreeNode();
        newNode.id = entidad.codigo_principal + entidad.codigo_Secundario;
        newNode.name = entidad.descripcion;
        newNode.children = new Array<TreeNode>();
        this._cscaeService.GetEntidadesHijas(entidad.codigo_principal, entidad.codigo_Secundario)
            .subscribe(datas => {
                if (datas != null || datas != undefined) {
                    for (let entity of datas) {
                        let newNodeChild: TreeNode = new TreeNode();
                        newNodeChild.id = entity.codigo_principal + entity.codigo_Secundario;
                        newNodeChild.name = entity.descripcion;

                        newNode.children.push(newNodeChild);

                        let nodes = this.nodes;
                        this.nodes = [];
                        this.nodes = nodes;
                    }
                }
            });

        this.nodes[1].children.push(newNode);

        let nodes = this.nodes;
        this.nodes = [];
        this.nodes = nodes;

        console.log("nodohijos");
    }
}

/*    
EstaCargado(){
        this._cscaeService.TreeLoaded.subscribe((data) => {
            console.log("sus",data);
            if(data){
                

                setTimeout(function() {
                    console.log("cerrado");
                    this.sideBarAbierta = !this.sideBarAbierta;
                    //this.sideBarAbierta = false;
                    //this.toggleSideBar();
                     setTimeout(function() 
                        {
                            this.sideBarAbierta = !this.sideBarAbierta;
                        //this.sideBarAbierta = true;
                        //this.toggleSideBar();

                        console.log("abierto");
                        }, 5000);
                    
                  }, 300);
                //this.tree.treeModel.expandAll();
            }

        });
    }
    */

    Desplegar() {
        if (this.desplegado == false) {
            this.tree.treeModel.expandAll()
        } else {
            this.tree.treeModel.collapseAll()
        }
        this.desplegado = !this.desplegado;
    }

    CambioEntidad(tree: any, node: any, $event: any) {
        let cprimario = node.data.id.substring(0, 2);
        let csecundario = node.data.id.substring(2);
        this.Resumen(this.EjercicioActual, cprimario, csecundario)
        if (node.hasChildren && !(this.TambienPuedeEditar.indexOf(node.data.id) > -1)) { //Si tiene hijos pero aparece en tambien editar
            this.PuedeEditar = false;                                                     //se trata de una provincia que gestiona
        } else {
            this.PuedeEditar = true;
        };
        
        this.CodigoPrimario = cprimario;
        this.CodigoSecundario = csecundario;
        this._cscaeService.GetEntidad(cprimario, csecundario)
            .subscribe(data => this.EntidadActual = data);

            //this.toggleSideBar();
    }


    GetMes(mes: string) {
        switch (mes) {
            case "Enero":
                return "01";
            case "Febrero":
                return "02";
            case "Marzo":
                return "03";
            case "Abril":
                return "04";
            case "Mayo":
                return "05";
            case "Junio":
                return "06";
            case "Julio":
                return "07";
            case "Agosto":
                return "08";
            case "Septiembre":
                return "09";
            case "Octubre":
                return "10";
            case "Noviembre":
                return "11";
            case "Diciembre":
                return "12";
            default:
                return "00";
        }       
    }

    Resumen(ejercicio: number, codigoPrimario: string, codigoSecundario: string) {
        this.Loading = true;
        this.ResumenDatos = null;
        this._cscaeService.GetDatosResumen(codigoPrimario, codigoSecundario, ejercicio)
            .subscribe(data => {
                this.ResumenDatos = data;
                this.Loading = false;
            });
    }

    ViewData(ejercicio: any, mes: any) {
        this._cscaeService.GetDatos(this.CodigoPrimario, this.CodigoSecundario, ejercicio, mes)
            .subscribe(data => this.Datos = data);
    }

    Edit(Mes:string, template: TemplateRef<any>) {
        this.DatosEnviar.Ejercicio = this.EjercicioActual;
        this.MesActual = this.GetMes(Mes);
        this.MesActualString = Mes;

        this.ViewData(this.EjercicioActual, this.MesActual);
        this.openModalEdit();
    }

    SaveChanges() {
        this.DatosEnviar.CodigoPrimario = this.CodigoPrimario;
        this.DatosEnviar.CodigoSecundario = this.CodigoSecundario;
        this.DatosEnviar.Datos = this.Datos;
        this.DatosEnviar.Mes = this.MesActual;
        this._cscaeService.EditarDatos(this.DatosEnviar)
            .subscribe(result => {
                this.Resumen(this.EjercicioActual, this.CodigoPrimario, this.CodigoSecundario);
                this.closeModalEdit();
            }
        );
    }
    Cancel() {
        this.MesActual = "";
        this.Resumen(this.EjercicioActual, this.CodigoPrimario, this.CodigoSecundario);
        this.closeModalEdit();
    }

    toggleSideBar() {
        this.sideBarAbierta = !this.sideBarAbierta;
    }
    openModalEdit(){
        this.modalRef = this.modalService.show(this.ModalEdit,
            Object.assign({}, { class: 'modal-lg' }));
    }
    closeModalEdit(){
        this.modalRef.hide();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/home.component.ts